import useQuery from '_hooks/useQuery';

export default function useIsEditMode() {
  const query = useQuery();
  const eventId = query.get('id');
  const fromReHost = query.get('fromReHost') === '1';

  return Boolean(eventId && !fromReHost);
}
